import { useEffect } from "react";

interface SchemaOrgProps {
  schema: Record<string, unknown> | Record<string, unknown>[];
  id: string;
}

export default function SchemaOrg({ schema, id }: SchemaOrgProps) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [schema, id]);

  return null;
}
